<template>
    <nav
        id="header"
        class="bg-white w-full z-10 shadow-md sm:px-6 px-0"
        :class="{ 'fixed top-0': !isEpicvaultEnabled }"
    >
        <div
            class="w-full mx-auto flex flex-wrap items-center mt-0 pt-3 pb-3 lg:pb-0"
            :class="{ container: !isEpicvaultEnabled }"
        >
            <header-logo :is_epic_vault_enabled="isEpicvaultEnabled" />

            <div class="w-1/2 pr-0">
                <div class="float-right">
                    <epic-menu v-if="!isEpicvaultEnabled" />

                    <div
                        class="text-base text-right font-semibold pr-7"
                        :class="{ 'mt-2': !isEpicvaultEnabled }"
                        data-cy="nav-company-name"
                    >
                        {{ currentCompany }}
                    </div>

                    <multi-association-menu v-if="isEpicvaultEnabled" :is_epic_vault_enabled="isEpicvaultEnabled" />
                </div>
            </div>
        </div>

        <!-- Full Screen Nav -->
        <div class="container mx-auto hidden lg:block">
            <div
                class="flex items-center"
                :class="{ 'justify-between': !isEpicvaultEnabled, 'justify-end': isEpicvaultEnabled }"
            >
                <div v-if="!isEpicvaultEnabled">
                    <div
                        @click="gotoDashboard"
                        class="inline-block py-1 md:py-3 px-2 align-middle text-gray-500 no-underline border-b-2 border-white hover:text-highlight-purple hover:border-highlight-purple cursor-pointer"
                        :class="{
                            'text-default-purple hover:text-highlight-purple border-default-purple hover:border-highlight-purple':
                                currentLink == 'home',
                        }"
                        data-cy="nav-home"
                    >
                        <span class="pb-1 md:pb-0 text-sm">
                            {{ $t('globals.navigation.main.dashboard') }}
                        </span>
                    </div>
                    <div
                        @click="home_link.to"
                        class="inline-block py-1 md:py-3 px-2 align-middle text-gray-500 no-underline border-b-2 border-white hover:text-highlight-purple hover:border-highlight-purple cursor-pointer"
                        :class="{
                            'text-default-purple hover:text-highlight-purple border-default-purple hover:border-highlight-purple':
                                currentLink == 'claim',
                        }"
                        data-cy="nav-search"
                    >
                        <span class="pb-1 md:pb-0 text-sm">
                            {{ home_link.default ? $t('globals.navigation.main.search') : home_link.label }}
                        </span>
                    </div>
                </div>

                <multi-association-menu v-if="!isEpicvaultEnabled" :is_epic_vault_enabled="isEpicvaultEnabled" />
            </div>
        </div>
    </nav>
</template>

<script>
import HeaderLogo from '@/components/layout_sections/HeaderLogo.vue';
import EpicMenu from '@/components/layout_sections/DropDownMenu.vue';
import MultiAssociationMenu from '@/components/layout_sections/MultiAssociationMenu.vue';

export default {
    components: {
        HeaderLogo,
        EpicMenu,
        MultiAssociationMenu,
    },
    props: ['home_link'],
    computed: {
        currentCompany() {
            return this.$store.getters['user/currentCompanyName'];
        },
        currentLink() {
            return this.$store.getters['navigation/currentLink'];
        },
        isEpicvaultEnabled() {
            return this.$store.state.system.is_epicvault_enabled ? true : false;
        },
    },
    methods: {
        gotoDashboard() {
            this.$router.push({ name: 'home' });
        },
    },
};
</script>
